import React from 'react'
import { cn } from '../utils/utils'
import { InfoCircleIcon } from '../components/ui/icons/info-circle'
import { Tooltip as TooltipEl, TooltipContent, TooltipTrigger } from '../components/ui/tooltip'

interface TooltipProps {
    children: React.ReactNode
    className?: string
}

// Old Tooltip
//
// export function Tooltip2({ children, className }: TooltipProps) {
//     const classes = cn('relative inline-block cursor-pointer group', className)
//     return (
//         <div className={classes}>
//             <InfoCircleIcon className="size-4" />
//             <div className="invisible text-sm absolute z-[100] w-fit text-left max-w-96 bg-blue20 text-blue40 px-[14px] py-2.5 border border-blue40 rounded-md group-hover:visible mt-1">
//                 {children}
//             </div>
//         </div>
//     )
// }

export function Tooltip({ children, className }: TooltipProps) {
    return (
        <TooltipEl>
            <TooltipTrigger className={className}>
                <InfoCircleIcon className="size-4" />
            </TooltipTrigger>
            <TooltipContent side="bottom" sideOffset={8} avoidCollisions collisionPadding={8}>
                {children}
            </TooltipContent>
        </TooltipEl>
    )
}
